import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";
import {useTheme} from "@material-ui/core/styles";

type Props = {
  disabled?: boolean;
};

const AIAssistantIcon = ({disabled}: Props) => {
  const theme = useTheme();

  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 19L7.5 13.5L2 11L7.5 8.5L10 3L12.5 8.5L18 11L12.5 13.5L10 19ZM18 21L16.75 18.25L14 17L16.75 15.75L18 13L19.25 15.75L22 17L19.25 18.25L18 21Z"
        fill={disabled ? theme.palette.action.disabled : "#2979FF"}
      />
    </SvgIcon>
  );
};

export default AIAssistantIcon;
